<template>
    <div id="CedianGroup">
        <div class="data_head">
            <span class="cedian_text">展示类型</span>
            <el-select v-model="showType" value-key="id" placeholder="请选择展示类型">
                <el-option label="默认" value="1"></el-option>
                <el-option label="测斜分孔" value="2"></el-option>
            </el-select>
            
            <span class="cedian_text">分组名称</span>
            <el-input v-model="groupName" clearable placeholder="请输入分组名称"></el-input>
            
            <!--            <span class="cedian_text">基准点</span>-->
            <!--            <el-select v-model="baseMeasureNo" value-key="id" @change="selectmainMeasureNo">-->
            <!--                <el-option v-for="item in projectInfo" :key="item.id" :label="item.measureNo" :value="item"></el-option>-->
            <!--            </el-select>-->
            <!-- 下拉框多选 multiple-->
            <span class="cedian_text">子测点</span>
            <el-select multiple collapse-tags v-model="childMeasuerNo" value-key="id" @change="selectchildMeasureNos">
                <el-option v-for="item in childCedianInfo" :key="item.id" :label="item.measureNo"
                           :value="item.measureNo"></el-option>
            </el-select>
            
            
            <el-button type="warning" @click="save()">保&nbsp;存</el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%;" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column align="center" prop="groupName" label="分组名称"></el-table-column>
                <el-table-column align="center" prop="groupName" label="展示类型">
                    <template slot-scope="scope">
                        {{ scope.row.showType == 1 ? "默认" : scope.row.showType == 2 ? "测斜分孔" : "" }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="mainMeasureNo" label="基准点"></el-table-column>
                <el-table-column align="center" prop="childMeasureNos" label="子测点"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="editSortMeasureGroup(scope.row)">修改分孔测点顺序
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删 除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @current-change="handleCurrentChange" :current-page="page"
                    :hide-on-single-page="true"
                    :page-size="pageSize" layout="total,prev, pager, next, jumper"
                    :total="total" class="pagination" background>
                </el-pagination>
            </div>
        </div>
        
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body="false">
            <span>删除不可恢复，是否确定删除？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="del">确 定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog title="修改分孔测点顺序" :visible.sync="sortMeasureGroupDialogVisible" :close-on-click-modal="false"
                   :modal-append-to-body="false"
                   :close-on-press-escape="false" width="40%" top="10vh">
            <div class="sortMeasureGroupDialog-text">该顺序表示距离从孔底到孔顶，排序权重依次增加</div>
            <div class="sortMeasureGroupDialog-tree">
                <el-tree
                    ref="sortMeasureGroupRef"
                    :data="sortMeasureGroupArr"
                    node-key="measureNo"
                    :props="sortMeasureGroupProps"
                    :allow-drop="sortMeasureGroupAllowDrop"
                    @node-drop="sortMeasureGroupNodeDrop"
                    draggable>
                    <span slot-scope="{node,data}" class="sortMeasureGroupDialog-label">
                        <div>子测点名称：{{ node.label }}</div>
                        <div>排序权重：{{ data.pointOrder }}</div>
                    </span>
                </el-tree>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="sortMeasureGroupDialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="saveSortMeasureGroupDialog()">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "CedianGroup",
    components: {},
    data() {
        return {
            showType: "",
            groupName: "",
            data: [],
            list: [], // 用于存放数据
            projectInfo: [], // 基准点下拉框数据
            total: null,
            page: 1, // 初始页
            pageSize: 10, // 每页显示的数据条数
            baseMeasureNo: "", // 基准点
            childMeasuerNo: [], // 子测点
            delDialogVisible: false,
            mainMeasureNo: "",
            childMeasureNos: [],
            childCedianInfo: [], // 子测下拉框定数据
            sortMeasureGroupDialogVisible: false,
            sortMeasureGroupId: "",
            sortMeasureGroupArr: [],
            sortMeasureGroupProps: {
                label: "measureNo",
                isLeaf: false
            }
        };
    },
    mounted: function() {
        this.getData(); // 表格数据接口
        this.getAllMeasures(); // 基准点与子测点数据接口
    },
    methods: {
        saveSortMeasureGroupDialog() {
            this.$confirm("确认保存？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let obj = {
                    id: this.sortMeasureGroupId,
                    pointOrderList: this.sortMeasureGroupArr
                }
                this.$axios.post("/api/monitor/project/measureGroup/updatePointOrder", obj).then(res => {
                    let data = res.data
                    if (data.status == 200) {
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        this.sortMeasureGroupDialogVisible = false
                        this.getData()
                    } else {
                        this.$message({
                            message: data.message,
                            type: "error"
                        });
                    }
                })
            })
        },
        sortMeasureGroupNodeDrop() {
            this.sortMeasureGroupArr.forEach((data, index) => {
                data.pointOrder = index + 1
            })
        },
        sortMeasureGroupAllowDrop(draggingNode, dropNode, type) {
            if (type == "inner") {
                return false
            }
            return true
        },
        editSortMeasureGroup(row) {
            this.$axios.post("/api/monitor/project/measureGroup/holeInfo", {
                measureGroupId: row.id
            }).then(res => {
                let data = res.data
                if (data.status == 200) {
                    this.sortMeasureGroupId = row.id
                    this.sortMeasureGroupArr = data.datas.values
                    this.sortMeasureGroupDialogVisible = true
                } else {
                    this.$message({
                        message: data.message,
                        type: "error"
                    });
                }
            });
        },
        getData() {
            this.$axios.post("/api/monitor/project/measureGroup/groupList", {}).then(res => {
                if (res.data.status == 200) {
                    this.total = res.data.datas.values.length;
                    this.data = res.data.datas.values;
                    this.list = this.data.filter((item, index) =>
                        index < this.page * this.pageSize && index >= this.pageSize * (this.page - 1)
                    );
                }
                return
            });
        },
        getAllMeasures() {
            this.$axios.get("/api/monitor/project/measureGroup/getAllMeasures", {}).then(res => {
                if (res.data.status == 200) {
                    this.childCedianInfo = res.data.datas.values;
                    // this.projectInfo = res.data.datas.values;
                }
                return
            })
        },
        selectmainMeasureNo(event) {
            this.mainMeasureNo = event.measureNo;
            this.$axios.get(`/api/monitor/project/measureGroup/getAllMeasures?measureNo=${ event.measureNo }`).then(res => {
                if (res.data.status == 200) {
                    this.childCedianInfo = res.data.datas.values;
                }
                return
            })
        },
        selectchildMeasureNos(e) {
            console.log(e, 111111)
            this.childMeasureNos = e;
        },
        handleCurrentChange(val) {
        
        },
        handleDelete(row) {
            this.mainMeasureNo = row.mainMeasureNo;
            this.id = row.id;
            this.delDialogVisible = true;
        },
        del() {
            const req = {
                mainMeasureNo: this.mainMeasureNo,
                id: this.id
            }
            this.$axios.post("/api/monitor/project/measureGroup/delGroup", req).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    this.delDialogVisible = false;
                    this.getData();
                }
                return
            })
        },
        save() {
            if (!this.showType) {
                this.$message({
                    message: "请选择展示类型",
                    type: "error"
                });
                return
            }
            if (!this.groupName) {
                this.$message({
                    message: "请输入分组名称",
                    type: "error"
                });
                return
            }
            if (this.childMeasureNos.length == 0) {
                this.$message({
                    message: "请选择子测点",
                    type: "error"
                });
                return
            }
            const req = {
                showType: this.showType,
                // mainMeasureNo: this.mainMeasureNo,
                childMeasureNos: this.childMeasureNos.join(","),
                groupName: this.groupName
            }
            this.$axios.post("/api/monitor/project/measureGroup/createGroup", req).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        message: "保存成功",
                        type: "success"
                    });
                    this.baseMeasureNo = "";
                    this.childMeasuerNo = [];
                    this.getData();
                }
                if (res.data.status == 700) {
                    this.$message({
                        message: "请勿重复添加基准点",
                        type: "error"
                    });
                    this.baseMeasureNo = "";
                    this.childMeasuerNo = [];
                    this.getData();
                }
                return
            })
        }
    }
}
</script>

<style>
#CedianGroup .el-input {
    max-width: 203px;
}

#CedianGroup .el-input .el-input__inner {
    background-color: #3457DE;
    color: #FFF; /* 选择后显示的颜色 */
}

#CedianGroup .el-select .el-input__inner {
    background-color: #3457DE;
    color: #FFF; /* 选择后显示的颜色 */
}

#CedianGroup .el-table {
    color: #A7CCF6;
}

#CedianGroup .el-table__row {
    background-color: #0B3A68 !important;
}

#CedianGroup .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #021535;
}

#CedianGroup .el-table td {
    border: unset;
}

#CedianGroup .el-table th.is-leaf {
    border-bottom: none;
}

/* 加下列代码否则受#deviceStatic .el-table, .el-select-dropdown中background影响,会透明色 */
#CedianGroup .el-table, .el-select-dropdown {
    background: #FFF;
}

#CedianGroup .cedian_text:not(:first-child) {
    margin-left: 15px;
}

#CedianGroup .data_head .el-button {
    margin-left: 15px;
}

</style>

<style scoped>
@import url('../../../assets/css/style.css');

.pagination {
    margin-top: 30px;
    text-align: center;
}

.cedian_text {
    color: #FFF;
}

/deep/ .el-dialog__body {
    padding: 15px 20px;
    padding-top: 0;
}

/deep/ .el-tree-node__content:hover, .el-upload-list__item:hover {
    background-color: #C0C4CC;
}

.sortMeasureGroupDialog-text {
    width: 100%;
    margin-bottom: 10px
}

.sortMeasureGroupDialog-tree {
    width: 100%;
    max-height: 550px;
    overflow-y: auto
}

.sortMeasureGroupDialog-label {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start
}

.sortMeasureGroupDialog-label > div:nth-child(1) {
    width: 60%
}

.sortMeasureGroupDialog-label > div:nth-child(2) {
    width: 30%
}
</style>




// WEBPACK FOOTER //
// src/components/project/CedianGroup/CedianGroup.vue